
export const generateFilterKey = (workflowIndex, caseStateId) => {
    return `selectedFilters_${workflowIndex}_${caseStateId}`;
}

export const generateUniqueKey = () => {
    return '_' + Math.random().toString(36).substring(2, 9);
}